import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export default function Mirror(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12,5.84c-3.41,0-6.16,2.75-6.16,6.16c0,3.41,2.75,6.16,6.16,6.16s6.16-2.75,6.16-6.16C18.15,8.59,15.4,5.84,12,5.84
			L12,5.84z M12,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4s4,1.8,4,4C16,14.2,14.2,16,12,16L12,16z M18.41,4.16
			c-0.8,0-1.44,0.64-1.44,1.44c0,0.8,0.64,1.44,1.44,1.44c0.8,0,1.44-0.64,1.44-1.44C19.84,4.8,19.2,4.16,18.41,4.16L18.41,4.16z
			 M18.41,4.16"
      />
      <path
        d="M24,12c0-1.66,0.02-3.3-0.08-4.95c-0.09-1.92-0.53-3.63-1.94-5.03c-1.41-1.41-3.11-1.84-5.03-1.94C15.3-0.01,13.65,0,12,0
			c-1.66,0-3.3-0.01-4.95,0.08C5.13,0.17,3.42,0.61,2.02,2.02C0.61,3.42,0.17,5.13,0.08,7.05C-0.01,8.7,0,10.35,0,12
			c0,1.65-0.01,3.3,0.08,4.95c0.09,1.92,0.53,3.63,1.94,5.03c1.41,1.41,3.11,1.84,5.03,1.94C8.7,24.01,10.35,24,12,24
			c1.66,0,3.3,0.02,4.95-0.08c1.92-0.09,3.63-0.53,5.03-1.94c1.41-1.41,1.84-3.11,1.94-5.03C24.02,15.3,24,13.66,24,12L24,12z
			 M21.36,19.08c-0.22,0.55-0.48,0.95-0.91,1.37c-0.42,0.42-0.83,0.69-1.37,0.91c-1.58,0.63-5.33,0.49-7.08,0.49
			s-5.5,0.14-7.08-0.48c-0.55-0.22-0.95-0.48-1.37-0.91c-0.42-0.42-0.69-0.83-0.91-1.37C2.01,17.5,2.15,13.75,2.15,12
			c0-1.75-0.14-5.5,0.48-7.08c0.22-0.55,0.48-0.95,0.91-1.37c0.42-0.42,0.83-0.69,1.37-0.91C6.49,2.01,10.25,2.15,12,2.15
			s5.5-0.14,7.08,0.48c0.55,0.22,0.95,0.48,1.37,0.91c0.42,0.42,0.69,0.83,0.91,1.37c0.62,1.58,0.48,5.33,0.48,7.08
			C21.84,13.75,21.98,17.5,21.36,19.08L21.36,19.08z M21.36,19.08"
      />
    </SvgIcon>
  )
}
